export const DEFAULT_PAGE_NAME = 'Default Page';
export const DEFAULT_PAGE_LAYOUT = '@';
export const DEFAULT_PAGE_SLUG = 'default-page';
